module.exports = __webpack_public_path__ + "static/media/S (197).4720e434.jpg";